import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UploadProofComponent } from '../upload-proof/upload-proof.component';
import Swal from 'sweetalert2';
import { AccreditationFinancialService } from 'src/app/features/cabs/modules/accreditation-financial/services/accreditation-financial.service';
import { AllTrainingListService } from 'src/app/features/training/services/all-training-list.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './payment-modal.component.html',
  styles: [],
})
export class PaymentModalComponent implements OnInit {
  loading = false;

  HasedRequestObject: any = '';
  RandomSecret: any = '';
  RequestObject: any = '';
  SenderID: any = '';
  payment_gateway_url: any = '';
  dataLoading = false;
  paymentOptions: any = [];
  onlineLoading = false;

  ShowBankTransfer: boolean = !environment.production;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PaymentModalComponent>,
    private toastr: ToastrService,
    private accreditationFinancialService: AccreditationFinancialService,
    private allTrainingListService: AllTrainingListService,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    console.log(this.data);
    this.getPaymentOptions();
  }

  getPaymentOptions() {
    this.dataLoading = true;
    const model = {
      currency_token: this.data.data.currency_token
    };
    this.accreditationFinancialService.getPaymentOptions(model).subscribe(
      (res) => {
        this.dataLoading = false;
        this.paymentOptions = res.data;
        console.log(res);
        if (this.data.data.is_training_manager) {
          this.paymentOptions = [
            {
              option_token: "HAG43234dAHHrtrBNt8gu9CjWp1vzPkK434xvSJ",
              option_name: "Direct payment confirmation",
            },
            ...res.data
          ]
        }


      },
      (err) => {
        this.showError(err.message);
        this.dataLoading = false;
      }
    );

  }

  onUploadProof(payment_option: number, payment_option_name: string) {
    console.log(this.data);
    const dialogRef = this.dialog.open(UploadProofComponent, {
      width: '450px',
      data: { courseToken: this.data.courseToken, payment_option, TM_FM_Pay: this.data.TM_FM_Pay, enrollment_token: this.data.enrollment_token },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close(true);
      }
    });

  }



  onlinePay() {
    this.onlineLoading = true;
    const obj = {
      payment_token: this.data.courseToken,
      type: 0,   // 0 => Training , 1 => Entity
    };
    this.accreditationFinancialService.onlinePayment(obj).subscribe((res) => {
      // this.onlineLoading = false;

      // this.HasedRequestObject = res.HasedRequestObject;
      // this.RandomSecret = res.RandomSecret;
      // this.RequestObject = res.RequestObject;
      // this.SenderID = res.SenderID;
      // this.payment_gateway_url = res.payment_gateway_url;
      // setTimeout(() => {
      //   let form: HTMLFormElement = <HTMLFormElement>document.getElementById('redirectToPay');
      //   form.submit();
      // }, 10);
      window.location.href = res.paymentGatewayURL;
    },
      (err) => {
        this.onlineLoading = false;

        err.message.forEach(element => {
          this.showError(element.message);
        })

      });
  }

  onOfficePay() {
    Swal.fire({
      title: 'Are you sure',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        const model = {
          course_token: this.data.courseToken,
          payment_option: 2,
        };
        this.allTrainingListService.traineePayment(model).subscribe(
          (res) => {
            this.dialogRef.close(true);
            Swal.fire({
              title: 'Success',
              text: 'Your request has been successfully registered, Thank you',
              icon: 'success',
              confirmButtonText: 'Ok',
            });
            this.loading = false;
          },
          (err) => {
            // console.log(err);
            this.toastr.error(err.message);
            this.loading = false;
          }
        );
      }
    });
  }


  DirectlyConfirmPayment(payment_option) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.yes'),
      cancelButtonText: this.translate.instant('swalMsg.cancel'),
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        const model = {
          // course_token: this.data.courseToken,
          payment_option: payment_option,
          enrollment_token: this.data.enrollment_token
        };
        // debugger
        //when TM_FM_Pay fees for trainee front training detailes => tap "Payments"
        this.allTrainingListService.TM_FM_Payment(model).subscribe(
          (res) => {
            // debugger
            this.dialogRef.close(true);
            Swal.fire({
              title: this.translate.instant('swalMsg.success'),
              text: this.translate.instant('swalMsg.Your request has been successfully registered, Thank you'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.ok'),
            });
            this.loading = false;
          },
          (err) => {
            this.toastr.error(err.message);
            this.loading = false;
          }
        );
      }
    });
  }


  showError(msg) {
    this.toastr.error(msg);
  }

  showSuccess(msg) {
    this.toastr.success(msg);
  }
}
